export default [
  {
    path: '/transfer',
    name: 'transfer',
    component: () => import('@/views/recharge/Transfer.vue'),
    meta: {
      action: 'B2B',
       resource: 'B2BUser',
      auth: true,
    },
  },
]
